// UT30 is an unique code to identify each widget in the BPPR ecosystem
export const UT30APIConnect = '30A3M';

// email configuration json to send feedback email
export const emailCOSJson = 'apiconnectpe.json';

// Product Title & page url for creating CIs
export const productTitle = 'API Connect Price Estimator';
export const pageUrl = '/products/api-connect/pricing';

// Offerings
export const BASE = 'Base';
export const ADVANCED = 'Advanced';
export const RESERVED_INSTANCE = 'Reserved Instance';
export const SOFTWARE = 'Software';

export const REGEX = new RegExp('^[01-9,]*$'); // Regex to validate input value for api call volumes
